module.exports = __webpack_public_path__ + "img/logo-mit.3e8a7fc9.png";